export default "__VITE_ASSET__DyzYTqUt__"